import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Email } from '../../../core/data';
import { markAsTouched } from '../../utils';
import { emailValidator, requiredValidator } from '../../validators';

@Component({
  selector: 'app-email-modal',
  templateUrl: './email-modal.component.html',
})
export class EmailModalComponent {
  active = false;
  form = new FormGroup({
    id: new FormControl(),
    address: new FormControl(null, [
      requiredValidator(),
      emailValidator(),
      Validators.maxLength(255),
    ]),
  });

  @Output() onChange = new EventEmitter<Email>();

  open(email?: Email) {
    if (email) {
      this.form.patchValue(email);
    }

    this.active = true;
  }

  close() {
    this.form.reset();
    this.active = false;
  }

  submit() {
    if (this.form.valid) {
      this.onChange.emit(this.form.value);
    } else {
      markAsTouched(this.form);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/contacts/email-modal.component.ts